import { useEffect } from 'react';

import {
  usePostThreatMetrixMutation,
  usePutThreatMetrixMutation,
} from '../../api/lendingApi/lendingApiMutations';
import { useGetContext } from '../../api/lendingApi/lendingApiQueries';
import { getRuntimeEnvironment } from '../../utils/getRuntimeEnvironment';

const THREATMETRIX_ORG_ID = '8u0q6ob5';

export const ThreatMetrix = () => {
  const { context } = useGetContext();
  const { tmSessionId, mutatePostThreatMetrix } = usePostThreatMetrixMutation();
  const { mutatePutThreatMetrix } = usePutThreatMetrixMutation();

  const environment = getRuntimeEnvironment();

  useEffect(() => {
    const activateThreatMetrix = async () => {
      if (typeof context?.state_key !== 'string') return;

      const { tmSessionId } = await mutatePostThreatMetrix({
        stateKey: context.state_key,
      });

      //@ts-expect-error expect threatmetrix on window
      if (window.threatmetrix) {
        //@ts-expect-error expect threatmetrix on window
        window.threatmetrix.profile(
          'h.online-metrix.net',
          THREATMETRIX_ORG_ID,
          tmSessionId,
        );

        mutatePutThreatMetrix({
          stateKey: context.state_key,
          tmSessionId,
        });
      }
    };

    void activateThreatMetrix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);

  if (
    !tmSessionId ||
    !context?.state_key ||
    environment === 'staging' ||
    context.logged_in_user_type === 'staff'
  ) {
    return null;
  }

  return (
    <iframe
      data-testid="threatmetrix"
      style={{
        width: 100,
        height: 100,
        border: 0,
        position: 'absolute',
        top: '-5000px',
      }}
      title="Threatmetrix"
      src={`https://h.online-metrix.net/fp/tags?org_id=${THREATMETRIX_ORG_ID}&session_id=${tmSessionId}`}
    />
  );
};
